import { gateway } from "../../../gateway";

export const updateClients = async (token, payload) => {
  try {
    const res = await gateway.put(`/clients/`, payload, {
      headers: {
        Authorization: `${token}`,
      },
    });
    return res.data || res.data.data;
  } catch (error) {
    throw error;
  }
};
